module.exports = __webpack_public_path__ + "media/images/svg/clients/5-3b01434ed836745496313487592b47d6.svg";